<template>
  <v-layout row>
    <v-flex
      xs12
      sm8
      offset-sm2
      md6
      offset-md3
      lg6
      offset-lg3
      xl6
      offset-xl3
    >
      <div class="title">
        <h3 class="headline mb-0">{{ $t('reset_password') }}</h3>
      </div>
      <v-card
        flat
        class="px-2"
      >
        <progress-bar :show="form.busy"></progress-bar>
        <form
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-card-text>
            <!-- Email -->
            <email-input
              :form="form"
              :label="$t('email')"
              :v-errors="errors"
              :value.sync="form.email"
              name="email"
              v-validate="'required|email'"
            ></email-input>

            <!-- Password -->
            <password-input
              :form="form"
              :hint="$t('password_length_hint')"
              :v-errors="errors"
              :value.sync="form.password"
              v-on:eye="eye = $event"
              v-validate="'required|min:8|verify_password'"
              ref="password"
            ></password-input>

            <!-- Password Confirmation -->
            <password-input
              :form="form"
              :hide="eye"
              :label="$t('confirm_password')"
              :v-errors="errors"
              :value.sync="form.password_confirmation"
              data-vv-as="password"
              hide-icon="true"
              name="password_confirmation"
              v-validate="'required|confirmed:password'"
            ></password-input>

            <submit-button
              style="margin-top: 10px;"
              block
              :form="form"
              dark
              :color="colors.button1"
              :label="$t('reset_password')"
            ></submit-button>
          </v-card-text>
        </form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Form from 'vform'

export default {
  name: 'reset-view',
  layout: 'common',
  metaInfo () {
    return { title: this.$t('reset_password') }
  },
  data: () => ({
    form: new Form({
      token: '',
      email: '',
      password: '',
      password_confirmation: ''
    }),
    eye: true
  }),
  computed: {
    ...mapGetters('config', [
      'gid', 'rid', 'colors'
    ]),
    myLogo () {
      return window.config.sharedPictures + 'logo.png'
    },
  },
  methods: {
    async reset () {
      if (await this.formHasErrors()) return

      this.form.token = this.$route.params.token

      const response = await this.form.post('/api/password/reset')

      // Login user if reset successful.
      const { data } = await this.form.post('/api/login')

      // Save the token.
      this.$store.dispatch('auth/saveToken', {
        token: data.token,
        remember: false
      })

      this.$store.dispatch('cart/resetGuestDetails')
      await this.$store.dispatch('auth/fetchUser')
      await this.$store.dispatch('fetchMemberAll')
      await this.$store.dispatch('fetchMembershipInfo')

      this.$store.dispatch('responseMessage', {
        type: 'success',
        text: response.data.msg
      })

      if (!this.gid || !this.rid) {
        this.$router.push({ name: 'advertised_outlets' })
      } else {
        this.$router.push({ name: 'welcome' })
      }
    }
  }
}
</script>

<style scoped>
.title {
  margin-top: 15px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/password/reset.vue